<div class="text-center modal-header" [class.with-cross]="cross">
  <mat-icon *ngIf="cross" (click)="close.emit(true)">close</mat-icon>
  <span class="title" *ngIf="!(title | isArray); else titleArray">{{ title | translate }}</span>

  <ng-template #titleArray>
    <span class="title" *ngFor="let word of title">{{ (word | translate) + ' ' }}</span>
  </ng-template>
</div>
